var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 26.3299C19.6099 26.3299 17.6699 24.3899 17.6699 21.9999C17.6699 19.6099 19.6099 17.6699 21.9999 17.6699C24.3899 17.6699 26.3299 19.6099 26.3299 21.9999C26.3299 24.3899 24.3899 26.3299 21.9999 26.3299ZM21.9999 19.1699C20.4399 19.1699 19.1699 20.4399 19.1699 21.9999C19.1699 23.5599 20.4399 24.8299 21.9999 24.8299C23.5599 24.8299 24.8299 23.5599 24.8299 21.9999C24.8299 20.4399 23.5599 19.1699 21.9999 19.1699Z",
    fill: "#333B47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 31.0205C18.2401 31.0205 14.6901 28.8205 12.2501 25.0005C11.1901 23.3505 11.1901 20.6605 12.2501 19.0005C14.7001 15.1805 18.2501 12.9805 22.0001 12.9805C25.7501 12.9805 29.3001 15.1805 31.7401 19.0005C32.8001 20.6505 32.8001 23.3405 31.7401 25.0005C29.3001 28.8205 25.7501 31.0205 22.0001 31.0205ZM22.0001 14.4805C18.7701 14.4805 15.6801 16.4205 13.5201 19.8105C12.7701 20.9805 12.7701 23.0205 13.5201 24.1905C15.6801 27.5805 18.7701 29.5205 22.0001 29.5205C25.2301 29.5205 28.3201 27.5805 30.4801 24.1905C31.2301 23.0205 31.2301 20.9805 30.4801 19.8105C28.3201 16.4205 25.2301 14.4805 22.0001 14.4805Z",
    fill: "#333B47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.e1a81aacbd33e88480fda5db71a55aba.svg";
export { ForwardRef as ReactComponent };